import React from 'react';
import {Paper, Avatar, Button, Grid, Fade} from '@mui/material';
import Typography from '@mui/material/Typography';
import styled from 'styled-components';

const BannerContainerStyles = styled.div`
  display: ${props => (props.open ? 'block' : 'none')};
  position: fixed;
  width: 100%;
  z-index: 20;
  top: ${props => (props.collapsedAppBar ? '2.625rem' : '7.125rem')}; // AppBarHeight 72px + TabBarHeight 42px
  transition: top 0.3s;
`;

const Banner = ({open, text, icon, primaryAction, secondaryAction, className}) => {
  const BannerIcon = icon ? (
    <Avatar
      sx={theme => ({
        backgroundColor: theme.palette.primary.main,
      })}>
      {icon}
    </Avatar>
  ) : null;

  const PrimaryActionButton = primaryAction ? (
    <Button color='secondary' onClick={primaryAction.action}>
      {primaryAction.label}
    </Button>
  ) : null;

  const SecondaryActionButton = secondaryAction ? (
    <Button color='secondary' onClick={secondaryAction.action}>
      {secondaryAction.label}
    </Button>
  ) : null;

  const Actions =
    primaryAction || secondaryAction ? (
      <Grid
        sx={{
          margin: 0,
          width: 'auto',
        }}
        container
        item
        justifyContent='flex-end'
        direction='row'
        wrap='nowrap'
        spacing={2}>
        <Grid item>
          {SecondaryActionButton}
          {PrimaryActionButton}
        </Grid>
      </Grid>
    ) : null;

  return (
    <BannerContainerStyles open={open} className={className}>
      <Fade in={open}>
        <Paper
          sx={theme => ({
            padding: '1rem',
            [theme.breakpoints.up('sm')]: {
              display: 'flex',
              alignItems: 'center',
            },
          })}>
          <Grid spacing={2} container wrap='nowrap'>
            <Grid item>{BannerIcon}</Grid>
            <Grid item>
              <Typography>{text}</Typography>
            </Grid>
          </Grid>
          {Actions}
        </Paper>
      </Fade>
    </BannerContainerStyles>
  );
};

export {Banner, BannerContainerStyles};
